import $ from 'jquery';
import ExpandableContent from '../modules/expandable-content';

function initializeExpandableContent() {
  const $questionsExpandable = $('.js-expandable-questions');

  if ($questionsExpandable.length) {
    new ExpandableContent($questionsExpandable);
  }

  const $categoriesExpandable = $('.js-expandable-categories');

  if ($categoriesExpandable.length) {
    new ExpandableContent($categoriesExpandable);
  }
}

export default initializeExpandableContent;
